export default "__VITE_ASSET__DSddp_zb__"